export const testIds = {
  THANK_YOU_PAGE_TRACKING_LINK_CONTAINER: 'thank-you-page-tracking-link',
};

export default {
  testIds,
};
